import { forwardRef, Ref, SVGProps } from 'react'

function _IconScales(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M1.14307 5.19995H14.8573"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2.91431V5.20002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.917672 10.8571L3.8331 5.19995L6.50282 10.8571C6.87196 12.9748 5.7531 13.7714 3.83424 13.7714C1.91539 13.7714 0.549672 12.9748 0.918815 10.8571H0.917672Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.48945 10.8571L12.4049 5.19995L15.0746 10.8571C15.4437 12.9748 14.3249 13.7714 12.406 13.7714C10.4872 13.7714 9.12031 12.9748 9.48945 10.8571Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50298 10.8572C6.87098 12.9749 5.75212 13.7715 3.83327 13.7715C1.91441 13.7715 0.548695 12.9749 0.917838 10.8572H6.50298Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0743 10.8572C15.4423 12.9749 14.3234 13.7715 12.4046 13.7715C10.4857 13.7715 9.11998 12.9749 9.48913 10.8572H15.0743Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconScales = forwardRef(_IconScales)
